import {MutableRuleAbstract} from "./MutableRuleAbstract";
import {IRule} from "../../../../index";
import {nsRuleset} from "../../nsRuleset";
import {AvailableData} from "./AvailableData";
import RULE_DEFAULT = nsRuleset.RULE_DEFAULT;

export class MutableRule extends MutableRuleAbstract {

    constructor(availableData: AvailableData, rule: IRule = RULE_DEFAULT) {
        super(availableData);
        this.$original = rule;
        this.booleanoperator(rule.booleanoperator);
        this.attribute(rule.attribute);
        this.argumentoperator(rule.argumentoperator);
        this.argument(rule.argument);
        this.order(rule.order);
    }

}
